import { createSvgIconComponent } from "../";

export const IconSVG = createSvgIconComponent();
